module.exports = __webpack_public_path__ + "static/media/navigation-share.ea5cad5e.svg";